import { render } from "./ProjectUploadsStep.vue?vue&type=template&id=59835c26"
import script from "./ProjectUploadsStep.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectUploadsStep.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Admin/Project/ProjectUploadsStep.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "59835c26"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('59835c26', __exports__)) {
    api.reload('59835c26', __exports__)
  }
  
  module.hot.accept("./ProjectUploadsStep.vue?vue&type=template&id=59835c26", () => {
    api.rerender('59835c26', render)
  })

}


export default __exports__